
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"68","height":"68"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"34","cy":"34","r":"34","fill":"#3A6ACD"}}),_c('path',{attrs:{"fill":"#FEFEFE","d":"M37.318 26.003c1.186 0 3.162-.056 3.162-.056V22h-5.534s-3.557.112-3.557 3.336v5.226H28v4.133h3.389V46h4.8V34.695h4.122v-4.133h-4.122v-3.447s-.057-1.112 1.129-1.112"}})])])
      }
    
      }
    